module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/52.ed8efd95.png";